import type { ValorantRank } from 'generated/openapi';
import { type ImgHTMLAttributes, memo } from 'react';

import {
  getRankLabel,
  getValorantRankImageUrl,
} from '@/features/games/valorant/utils/rank';

export interface ValorantRankIconProps extends ImgHTMLAttributes<HTMLImageElement> {
  rank?: ValorantRank;
}

export const ValorantRankIcon = memo(function ValorantRankIcon({
  rank,
  alt,
  src,
  ...rest
}: ValorantRankIconProps) {
  const imageUrl = src || getValorantRankImageUrl(rank);
  const altText = alt || getRankLabel(rank);

  return <img src={imageUrl} alt={altText} {...rest} />;
});
